<template>
    <div>
        <v-btn-toggle class="eq5d-answer-options-toggle"
                      v-model="sourceValue"
                      @change="dataItemChanged">
            <div class="eq5d-answer-options">
                <v-btn :key="index"
                       :value="option.value"
                       v-html="`<div class='v-btn__content'>${option.text}</div>`"
                       active-class="eq5d-answer-btn-active"
                       v-for="(option, index) in options"
                       :disabled="controlDisabled == true"></v-btn>
            </div>
        </v-btn-toggle>
        <div v-if="isEmpty"
             class="eq5d-answer-options-validation text-center pa-1 error--text">
            This is required
        </div>
    </div>
</template>
<script>
    export default {
        props: ["value", "options", "required", "dataItemId", "controlDisabled"],
        data() {
            return {};
        },
        watch: {
            sourceValue: function (newValue) {
                // if (this.required && !newValue) {
                //   this.appendErrorItem({
                //     id: this.dataItemId,
                //     msg: "This is required"
                //   });
                // } else {
                //   this.removeErrorItem({
                //     id: this.dataItemId,
                //     msg: "This is required"
                //   });
                // }
                this.validateRequired(newValue);
            },
        },
        computed: {
            sourceValue: {
                get: function () {
                    return this.value;
                },
                set: function (value) {
                    if (value == undefined) {
                        this.$emit("input", "");
                    } else {
                        this.$emit("input", value);
                    }
                },
            },
            isEmpty: function () {
                if (this.required && (this.value === "" || this.value === undefined || this.value === null)) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        methods: {
            validateRequired: function (newValue) {
                if ((this.required && newValue === "") || newValue === undefined) {
                    this.$store.commit("appendErrorItem", {
                        id: this.dataItemId,
                        msg: "This is required",
                    });
                } else if (this.required && (newValue || newValue === 0)) {
                    this.$store.commit("removeErrorItem", {
                        id: this.dataItemId,
                        msg: "This is required",
                    });
                }
            },
            dataItemChanged: function () {
                this.$emit("change");
            },
        },
        mounted() {
            this.validateRequired(this.sourceValue);
        },
        beforeDestroy: function () {
            this.$store.commit("removeErrorItem", {
                id: this.dataItemId,
                msg: "This is required",
            });
        },
    };
</script>
<style>
        .eq5d-answer-options {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            /* height: 400px; */
        }
        /* .eq5d-answer-options button {
      height: 70px !important;

    } */
        .eq5d-answer-options-toggle .v-btn {
            text-transform: none;
        }

        .eq5d-answer-options-toggle .v-btn__content {
            white-space: normal !important;
            flex: auto;
            padding: 5px;
            flex-wrap: wrap;
            /* max-width: 100px;  */
        }

        .eq5d-answer-options-toggle .v-btn-toggle--selected {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        .eq5d-answer-options-toggle .theme--light.v-btn-toggle {
            background: none;
        }

        .eq5d-answer-btn-active {
            background-color: #1976d2 !important;
            color: #ffffff !important;
        }

        .eq5d-answer-options-toggle.v-btn-toggle .v-btn {
            opacity: 1;
            margin-bottom: 10px;
        }

        .eq5d-answer-options-toggle .v-btn:not(.v-btn--round).v-size--default {
            height: auto;
            min-height: 70px;
            min-width: 200px;
            max-width: 700px;
        }

        .eq5d-answer-options-validation {
            font-size: 12px;
        }
</style>
